
<ng-container>
  <div class="gmap" id="gmap"></div>
</ng-container>
<ng-container>
  <img class="gmapimg" src="">
</ng-container>
